var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function PencilEditNoteIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 21C2 20.4477 2.44577 20 2.99865 20H21.0014C21.5529 20 22 20.4438 22 21C22 21.5523 21.5542 22 21.0014 22H2.99865C2.44711 22 2 21.5561 2 21ZM19.8635 2.72076L21.2807 4.13792C22.0609 4.91815 22.0609 6.18317 21.2777 6.96638L11.3797 16.8644L7.65711 17.7985C6.58498 18.0675 5.9348 17.413 6.20296 16.3443L7.13706 12.6217L17.035 2.72374C17.8169 1.94186 19.0859 1.94318 19.8635 2.72076ZM11.0261 14.3895L9.61247 12.9758L8.94317 13.645L8.47383 15.5276L10.3482 15.0674L11.0261 14.3895ZM17.7422 7.67348L16.328 6.25629L11.0267 11.5617L12.4404 12.9753L17.7422 7.67348Z", fill: "" })));
}
export var PencilEditNoteIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: PencilEditNoteIconInner }, props))); };
//# sourceMappingURL=PencilEditNoteIcon.js.map